import { LAYER } from 'js/components/common/PopupManager/layers';
import { ADD_POPUP } from 'js/components/common/PopupManager/store/actions';
import { CardPopup } from './CardPopup';

export const showCardPopupAction = ({
    id,
    title,
    content,
    onClose,
    closeAll,
    layer = LAYER.CARD,
    isModal = false,
    articleId,
    ...other
}) => ({
    type: ADD_POPUP,
    payload: {
        id,
        component: CardPopup,
        title,
        content,
        onClose,
        closeAll,
        layer,
        isModal,
        articleId,
        ...other
    }
});
